import { useEffect, useState } from 'react';
import { api } from '../services/api.js';
import { localDB } from '../services/db.js';

// Fetch an authenticated snap and return an object URL + cleanup.
export const useSnapImage = (snapId) => {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    if (!snapId) return;
    let cancelled = false;
    let objectUrl = null;
    
    (async () => {
      try {
        // 1. Check local IndexedDB first (important for offline/pending snaps)
        const localSnap = await localDB.get('snaps', snapId);
        if (localSnap && localSnap.blob) {
          const localUrl = URL.createObjectURL(localSnap.blob);
          if (!cancelled) {
            objectUrl = localUrl;
            setSrc(objectUrl);
            return;
          } else {
            URL.revokeObjectURL(localUrl);
            return;
          }
        }

        // 2. Fallback to API
        const url = api.snapFileUrl(snapId);
        const res = await fetch(url, {
          credentials: 'same-origin'
        });

        if (!res.ok) {
          console.error(`[useSnapImage] Fetch failed for ${snapId}: ${res.status} ${res.statusText}`);
          return;
        }
        
        const blob = await res.blob();
        
        // Cache the blob locally for future offline use
        const contentType = res.headers.get('content-type');
        await localDB.put('snaps', { 
          id: snapId, 
          blob, 
          contentType, 
          created_at: Date.now() 
        });

        const localUrl = URL.createObjectURL(blob);
        if (!cancelled) {
          objectUrl = localUrl;
          setSrc(localUrl);
        } else {
          URL.revokeObjectURL(localUrl);
        }
      } catch (err) {
        console.error(`[useSnapImage] Error loading snap ${snapId}:`, err);
      }
    })();

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [snapId]);

  return src;
};
